import React, { Fragment } from 'react';
import { bundle } from '../../helpers';
import Markdown from 'react-markdown';
import classnames from 'classnames'; // Import images used.

import aviIcon from '../../../assets/discussions/images/avi_128.png';
import excelIcon from '../../../assets/discussions/images/excel_128.png';
import htmlIcon from '../../../assets/discussions/images/html_128.png';
import illustratorIcon from '../../../assets/discussions/images/illustrator_128.png';
import movieIcon from '../../../assets/discussions/images/movie_128.png';
import indesignIcon from '../../../assets/discussions/images/indesign_128.png';
import mpegIcon from '../../../assets/discussions/images/mpeg_128.png';
import pdfIcon from '../../../assets/discussions/images/pdf_128.png';
import photoshopIcon from '../../../assets/discussions/images/photoshop_128.png';
import powerpointIcon from '../../../assets/discussions/images/powerpoint_128.png';
import txtIcon from '../../../assets/discussions/images/txt_128.png';
import unknownIcon from '../../../assets/discussions/images/unknown_128.png';
import wordIcon from '../../../assets/discussions/images/word_128.png';
var AVAILABLE_ICONS = {
  avi: aviIcon,
  excel: excelIcon,
  html: htmlIcon,
  illustrator: illustratorIcon,
  movie: movieIcon,
  indesign: indesignIcon,
  mpeg: mpegIcon,
  pdf: pdfIcon,
  photoshop: photoshopIcon,
  powerpoint: powerpointIcon,
  txt: txtIcon,
  unknown: unknownIcon,
  word: wordIcon
};
export var produceContent = function produceContent(message) {
  return message.content.reduce(function (content, token) {
    switch (token.type) {
      case 'team':
        return "".concat(content).concat(token.value.name);

      case 'user':
        return "".concat(content).concat(token.value.displayName);

      case 'attachment':
        return content;

      case 'unknownUser':
        return 'an unknown user';

      default:
        return "".concat(content).concat(token.value);
    }
  }, '');
};

var editedClass = function editedClass(message) {
  return message.createdAt !== message.updatedAt ? 'is-edited' : '';
};

var SUPPORTED_IMAGE_MIMES = ['image/gif', 'image/png', 'image/jpeg', 'image/bmp', 'image/webp', 'image/x-icon', 'image/vnd.microsoft.icon'];

var thumbnailUrl = function thumbnailUrl(discussion, message, attachment) {
  return SUPPORTED_IMAGE_MIMES.includes(attachment.contentType) ? "".concat(bundle.spaceLocation(), "/app/discussions/api/v1/discussions/").concat(discussion.id, "/messages/").concat(message.id, "/files/").concat(attachment.thumbnailId, "/").concat(encodeURIComponent(attachment.filename.replace(/ /g, '_'))) : attachmentIcon(attachment);
};

var attachmentUrl = function attachmentUrl(discussion, message, attachment) {
  return "".concat(bundle.spaceLocation(), "/app/discussions/api/v1/discussions/").concat(discussion.id, "/messages/").concat(message.id, "/files/").concat(attachment.documentId, "/").concat(encodeURIComponent(attachment.filename.replace(/ /g, '_')));
};

var attachmentIcon = function attachmentIcon(attachment) {
  var iconType = attachment.contentType.split('/')[1];

  if (Object.keys(AVAILABLE_ICONS).includes(iconType)) {
    return AVAILABLE_ICONS[iconType];
  }

  return AVAILABLE_ICONS['unknown'];
};

var formatFileSize = function formatFileSize(fileSize) {
  if (fileSize < 1024) return fileSize + ' bytes';else if (fileSize < 1048576) return (fileSize / 1024).toFixed(2) + ' kb';else if (fileSize < 1073741824) return (fileSize / 1048576).toFixed(2) + ' mb';else return (fileSize / 1073741824).toFixed(2) + ' gb';
};

export var TextMessage = function TextMessage(_ref) {
  var discussion = _ref.discussion,
      message = _ref.message;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Markdown, {
    source: produceContent(message),
    skipHtml: true,
    linkTarget: "_blank"
  }), message.content.filter(function (c) {
    return c.type === 'attachment';
  }).map(function (attachment) {
    return /*#__PURE__*/React.createElement("div", {
      key: attachment.value.documentId,
      style: {
        display: 'flex',
        flexDirection: 'column',
        paddingBottom: '0.5em'
      }
    }, /*#__PURE__*/React.createElement("a", {
      href: attachmentUrl(discussion, message, attachment.value),
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React.createElement("img", {
      src: thumbnailUrl(discussion, message, attachment.value),
      alt: attachment.value.filename
    })), /*#__PURE__*/React.createElement("small", null, attachment.value.filename, " (", /*#__PURE__*/React.createElement("em", null, formatFileSize(attachment.value.size)), ")"));
  }));
};
export var Message = function Message(_ref2) {
  var discussion = _ref2.discussion,
      message = _ref2.message,
      actions = _ref2.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: "message ".concat(editedClass(message))
  }, /*#__PURE__*/React.createElement(TextMessage, {
    discussion: discussion,
    message: message
  }), actions && message.createdAt !== message.updatedAt && /*#__PURE__*/React.createElement("button", {
    className: "btn btn-link",
    onClick: function onClick() {
      return actions.history(message);
    }
  }, /*#__PURE__*/React.createElement("em", null, "(Edited)")), message.parent && /*#__PURE__*/React.createElement("div", {
    className: "message--parent"
  }, message.parent.unknown ? /*#__PURE__*/React.createElement("div", {
    className: "message message--missing"
  }, "(Message missing)") : message.parent.omitted ? null : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Message, {
    discussion: discussion,
    message: message.parent,
    actions: actions
  }), /*#__PURE__*/React.createElement("small", null, "\u2014 ", message.parent.createdBy.displayName || 'Unknown'))));
};
export var UserMessage = function UserMessage(_ref3) {
  var discussion = _ref3.discussion,
      message = _ref3.message,
      profile = _ref3.profile,
      actions = _ref3.actions;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames('message-list__item', {
      editing: actions && actions.editing && actions.editing.id === message.id,
      replying: actions && actions.replying && actions.replying.id === message.id
    })
  }, actions && /*#__PURE__*/React.createElement("ul", {
    className: "message-list__actions meta"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-link",
    onClick: function onClick() {
      return actions.reply(message);
    }
  }, "Reply")), message.createdBy.username === profile.username && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-sm btn-link",
    onClick: function onClick() {
      return actions.edit(message);
    }
  }, "Edit"))), /*#__PURE__*/React.createElement("div", {
    className: "message-bubble"
  }, /*#__PURE__*/React.createElement(Message, {
    discussion: discussion,
    message: message,
    actions: actions
  })));
};